import clsx from 'clsx'
import { Controller, useFormContext } from 'react-hook-form'
import ImageUploader from '../../ImageUploader/ImageUploader'
import { AdFormSchema } from '../AdForm/AdFormTypes'

interface GoogleWalletImageProps {
  defaultImage?: string
  width?: number
  height?: number
}

const GoogleWalletImage = ({ defaultImage, width, height }: GoogleWalletImageProps) => {
  const {
    control,
    clearErrors,
    setError,
    formState: { errors },
  } = useFormContext<AdFormSchema>()

  return (
    <div
      className={clsx(
        'bg-white rounded-md h-fit p-4',
        errors.passDetails?.googleWalletImage?.message && 'border-error'
      )}
      data-testid="image-input"
    >
      <Controller
        control={control}
        name="passDetails.googleWalletImage"
        rules={{ required: 'Google Wallet image is required.' }}
        render={({ field: { onChange } }) => (
          <ImageUploader
            subText="or drop an image to upload"
            criteria={`Image size ${width} x ${height} px (.jpg .png or .webp). Maximum 5MB.`}
            widthReq={width ?? 1032}
            heightReq={height ?? 336}
            defaultImg={defaultImage || ''}
            imageUrlCB={onChange}
            setErrorAdvert={error => setError('passDetails.googleWalletImage', error)}
            clearErrorsAdvert={clearErrors}
            imgType="GOOGLE_WALLET_IMAGE"
            formError={errors.passDetails?.googleWalletImage?.message ?? ''}
          />
        )}
      />
    </div>
  )
}

export default GoogleWalletImage
